import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/multiplex-sti-pcr-test-supporting-a-smooth-ivdr-journey")({
  head: () => buildRouteHead("/es/casos-de-exito/multiplex-sti-pcr-test-supporting-a-smooth-ivdr-journey", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/prueba-pcr-multiplex-para-its-apoyando-un-viaje-ivdr-sin-problemas", replace: true });
  },
});
